import script from "./ErrorDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorDisplay.vue?vue&type=style&index=0&id=77fdaf5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77fdaf5c"]])

export default __exports__